import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CompleteLegacyBatchBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const completeLegacyBatch = createAsyncThunk<void, CompleteLegacyBatchBody, { extra: Partial<Dependencies> }>(
  "batches/completeLegacyBatch",
  async (body: CompleteLegacyBatchBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.completeLegacyBatch(body);
  },
);

export const resetCompleteLegacyBatch = createAction("batches/resetCompleteLegacyBatch");
